/**
 * Источник данных рабочего пространства: режим, его кеш запросов и маршрутизатор
 * HTTP-клиента. Рабочий источник отправляет запросы на сервер как есть и пользуется общим
 * кешем приложения; учебный (features/training/trainingDataSource) -- свой кеш и фасад.
 */

import type { QueryClient } from '@tanstack/react-query';
import type { RequestRouter } from '@/api/client';
import { LIVE_MODE, type WorkspaceMode } from '@/features/training/types';

export interface WorkspaceDataSource {
	mode: WorkspaceMode;
	queryClient: QueryClient;
	/** null -- запросы идут на сервер без маршрутизации */
	router: RequestRouter | null;
}

export function liveDataSource(queryClient: QueryClient): WorkspaceDataSource {
	return { mode: LIVE_MODE, queryClient, router: null };
}
